import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { useTranslation } from 'react-i18next'
import { styled } from '@linaria/react'
import { css } from '@linaria/core'

import closeModal from '../../utils/closeModal'
import Icon from '../icon'
import modalBg from '../../assets/coin-shower/timer_bg.webp'
import Modal from '../common/modal'
import { Dayjs } from 'dayjs'
import { useEffect, useMemo, useState } from 'react'
import twoDigitsFormat from '../../utils/twoDigitsFormat'
import { getMexicoTime } from '../../utils/time'
import { Link } from '@tanstack/router'

const container = css`
  padding: 83px 110px 40px 60px;
  border-color: none;
  border: none;
  background: url(${modalBg});
  background-size: contain;
  background-repeat: no-repeat;
  aspect-ratio: 737 / 490;
  width: 360px;
  max-width: unset;
  @media (min-width: 1200px) {
    width: 500px;
    padding: 125px 160px 40px 60px;
  }
`

const Close = styled.button`
  display: flex;
  position: absolute;
  padding: 16px;
  top: -48px;
  right: 0;
  &:hover {
    opacity: 0.8;
  }
  @media (min-width: 1200px) {
    padding: 20px;
  }
`

const Message = styled.p`
  font-family: 'Avenir-Heavy';
  font-size: 15px;
  color: var(--txt);
  text-align: center;
  text-shadow: 2px 2px #000;
  &.big {
    font-size: 16px;
    margin-top: 12px;
    margin-bottom: 18px;
  }
  @media (min-width: 1200px) {
    font-size: 18px;
    &.big {
      font-size: 20px;
      margin-bottom: 18px;
    }
  }
`

const Title = styled.h3`
  font-family: 'Syncopate-Bold';
  font-size: 40px;
  font-style: italic;
  font-weight: bold;
  text-align: center;
  text-transform: uppercase;
  color: #f4f4f4ff;
  -webkit-text-stroke-width: 3px;
  -webkit-text-stroke-color: #d20c69ff;
  position: absolute;
  top: 38px;
  left: 30px;
  @media (min-width: 1200px) {
    top: 53px;
    font-size: 55px;
    -webkit-text-stroke-width: 4px;
  }
`

const Terms = styled(Link)`
  color: #fff;
  text-decoration: underline;
  font-size: 12px;
  text-align: center;
  width: 100%;
  display: block;
  margin-top: 8px;
  @media (min-width: 1200px) {
    font-size: 16px;
  }
`

interface TimerModalProps {
  claimTime: Dayjs
  disabled?: boolean
}

const TimerModal = ({ claimTime, disabled }: TimerModalProps) => {
  const { t } = useTranslation(['common', 'homeV2'])
  const [remainingTime, setRemainingTime] = useState(
    claimTime.add(24, 'hours').diff(getMexicoTime()),
  )
  const modal = useModal()

  useEffect(() => {
    const interval = setInterval(() => {
      setRemainingTime(prev => prev - 1000)
    }, 1000)

    if (!modal.visible) {
      clearInterval(interval)
    }

    return () => {
      clearInterval(interval)
    }
  }, [modal.visible])

  const formattedTime = useMemo(() => {
    const totalSeconds = Math.floor(remainingTime / 1000)
    const totalMinutes = Math.floor(totalSeconds / 60)
    const totalHours = Math.floor(totalMinutes / 60)

    return `${twoDigitsFormat(totalHours)}:${twoDigitsFormat(
      totalMinutes % 60,
    )}:${twoDigitsFormat(totalSeconds % 60)}`
  }, [remainingTime])

  return (
    <Modal id="coin-shower-game-timer" containerStyle={container}>
      <Close onClick={() => closeModal(modal)}>
        <Icon id="close" width="15" height="15" fill="#fff" />
      </Close>
      <Title>{t('sorry')}</Title>
      {!disabled ? (
        <Message>{t('used-chance')}</Message>
      ) : (
        <Message className="big">{t('no-deposit')}</Message>
      )}
      {!disabled && <Message className="bold">{formattedTime}</Message>}
      <Terms
        onClick={() => closeModal(modal)}
        to="/vip"
        search={{ tab: 'system', view: 'coin-shower-game-bonus' }}>
        {t('terms', { ns: 'homeV2' })}
      </Terms>
    </Modal>
  )
}

export default NiceModal.create(TimerModal)
